module.exports = __webpack_public_path__ + "static/media/29BDOS28.f5ce8fa9.jpg";